import BZAPIService from '../../../services/BZAPIService';
import { createOddLookup, useOddLookup } from './oddLookup';

// How many upgrade candidates a project has: the same ODD call, with the
// project's baseline as current_version, that the project view makes for its
// "Available Versions" list — so the list's "X of Y versions reviewed" matches
// the project page. Per project: undefined while loading, null if it failed.
const available = createOddLookup(async (vendorId, productId, versionId) => {
  const data = await BZAPIService.bsaGetBstSoftwareSuggestions(vendorId, productId, versionId);
  return ((data && data.results) || []).length;
});

const baselineArgs = project =>
  project.vendorId && project.productId && project.versionId
    ? [project.vendorId, project.productId, project.versionId]
    : null;

export default function useAvailableVersions(projects) {
  return useOddLookup(available, projects, baselineArgs);
}
